import { render, staticRenderFns } from "./media-file.vue?vue&type=template&id=3748a5c4&scoped=true&"
import script from "./media-file.ts?vue&type=script&lang=ts&"
export * from "./media-file.ts?vue&type=script&lang=ts&"
import style0 from "./media-file.scss?vue&type=style&index=0&id=3748a5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748a5c4",
  null
  
)

export default component.exports